import { Log } from 'oidc-client';

/**
 * Log configuration.
 * TODO: should be replaced in the future!
 * @export
 */
export function setupLog(): void {
    Log.logger = console;
    Log.level = Log.DEBUG;
}
